import ShoppingCart from '@/assets/icons/ShoppingCart.svg';
import { ImageLink } from '@/components/ImageLink';
import { QuantityBadge } from '@/components/QuantityBadge';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import * as Styled from './MiniBasket.styled';

interface MiniBasketProps {
  isPending: boolean;
  link: string;
  quantity: number;
}

export const MiniBasket = ({ isPending, link, quantity }: MiniBasketProps) => {
  const isWideScreen = useMediaQuery('(width >= 48rem)');
  const hideBasketCount = (window as any).HIDE_BASKET_ITEM_COUNT === true;

  return (
    <Styled.Wrapper>
      <ImageLink href={link} label="Basket" width={isWideScreen ? 31 : 24}>
        <ShoppingCart />
      </ImageLink>
      {!hideBasketCount && !isPending ? (
        <QuantityBadge
          diameter={isWideScreen ? 20 : 16}
          isBasket={true}
          label="Items in basket"
          quantity={quantity}
        />
      ) : null}
    </Styled.Wrapper>
  );
};
